var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 6.10938H1.0625",
    stroke: "#393939",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 14.875H2.39062C2.03838 14.875 1.70057 14.7351 1.4515 14.486C1.20243 14.2369 1.0625 13.8991 1.0625 13.5469V3.71875C1.0625 3.36651 1.20243 3.0287 1.4515 2.77962C1.70057 2.53055 2.03838 2.39063 2.39062 2.39062H14.6094C14.9616 2.39063 15.2994 2.53055 15.5485 2.77962C15.7976 3.0287 15.9375 3.36651 15.9375 3.71875V9.03125",
    stroke: "#393939",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51562 0.796875V3.98438",
    stroke: "#393939",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4844 0.796875V3.98438",
    stroke: "#393939",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4844 16.2031C14.2448 16.2031 15.6719 14.776 15.6719 13.0156C15.6719 11.2552 14.2448 9.82812 12.4844 9.82812C10.724 9.82812 9.29688 11.2552 9.29688 13.0156C9.29688 14.776 10.724 16.2031 12.4844 16.2031Z",
    stroke: "#393939",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4844 11.6875V13.0156H13.8125",
    stroke: "#393939",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageProperties);
export default __webpack_public_path__ + "static/media/manage-properties.f018768384862c68eccd9c499710e2c9.svg";
export { ForwardRef as ReactComponent };